export default "__VITE_ASSET__BCnwdNOs__"